import axios from "axios"

export default axios.create({
    baseURL: process.env.VUE_APP_USER_API_BASE,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})